import React from 'react';
import { Card, CardBody } from "reactstrap";
import defaultImage from "../../../../assets/images/if_dash/Vector.png";

function RecentExitCard({ color, recbadge, backgroundcolor, employName, post, Time, confidence, image, handleImageClick }) {
  return (
    <Card>
      <CardBody style={{ border: "1px solid #E4E4E7", borderRadius: "8px" }}>
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
          <div className="d-flex align-items-center gap-2">
            <img
              style={{
                height: "80px",
                width: "80px",
                borderRadius: "50%",
                objectFit: "cover"
              }}
              src={image || defaultImage} // ✅ Dynamic image with fallback
              alt="Detected Face"
              onClick={()=> handleImageClick(image || defaultImage)}
            />
            <div className="d-flex">
              <div>
                <h2 style={{ fontSize: "16px", fontWeight: "600" }}>
                  {employName}
                </h2>
                <p
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    color: "#4B5563",
                    margin: "0px",
                  }}
                >
                  {post}
                </p>
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: "#6B7280",
                    margin: "0px",
                  }}
                >
                  Detected at {Time}
                </p>
              </div>

              <div style={{ alignSelf: "flex-start" }}>
                <button
                  style={{
                    fontSize: "12px",
                    color: color,
                    backgroundColor: backgroundcolor,
                    padding: "3px 11px",
                    borderRadius: "30px",
                    border: "none",
                    marginLeft: "5px",
                    fontWeight: "600"
                  }}
                >
                  {recbadge}
                </button>

                <button
                  style={{
                    fontSize: "12px",
                    color: "#18181B",
                    backgroundColor: "#F4F4F5",
                    padding: "3px 11px",
                    borderRadius: "30px",
                    border: "none",
                    marginLeft: "5px",
                    fontWeight: "600"
                  }}
                >
                  Exit
                </button>
              </div>
            </div>
          </div>

          {/* Confidence Section */}
          <div>
            <h2
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#16A34A",
              }}
            >
              {confidence}
            </h2>
            {/* <p
              style={{
                fontSize: "12px",
                fontWeight: "600",
                color: "#6B7280",
                lineHeight: "13px"
              }}
            >
              Exit Camera
            </p> */}
          </div>
        </div>
      </CardBody>
    </Card>
  );
}

export default RecentExitCard;
